/**
 * ZhPdfViewerEmbed — Chinese (NMPA) supplementary-PDF viewer: the shared
 * BilingualPdfViewerEmbed bound to `/zh_pdf`.  A Han query is boxed on the
 * Chinese page (1:1); an English query is highlighted in the panel only.  The
 * Han-only script regex carries NO kana, so Japanese never routes here.
 */
import { forwardRef } from 'react';
import { zhPdfApi } from '../../api/createViewerApi';
import { authApi } from '../../services/authApi';
import BilingualPdfViewerEmbed, {
  type BilingualPdfViewerEmbedProps,
  type BilingualPdfViewerHandle,
  type BilingualViewerConfig,
} from './BilingualPdfViewerEmbed';

export type ZhPdfViewerHandle = BilingualPdfViewerHandle;

const ZH_CONFIG: BilingualViewerConfig = {
  viewerApi: zhPdfApi,
  translate: (text, preserveHtml, docId, sectionId) =>
    authApi.translateZhPdfText(text, preserveHtml, docId, sectionId),
  sourceLabel: '中文 (source)',
  sourceName: 'Chinese',
  sourceScriptRe: /[一-鿿]/,
  regionTextField: 'text_zh',
  titleSrcField: 'title_zh',
  docSearch: 'byScript',
};

const ZhPdfViewerEmbed = forwardRef<ZhPdfViewerHandle, BilingualPdfViewerEmbedProps>(
  function ZhPdfViewerEmbed(props, ref) {
    return <BilingualPdfViewerEmbed ref={ref} config={ZH_CONFIG} {...props} />;
  },
);

export default ZhPdfViewerEmbed;
